"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var SvgCertifiedIconActive = function (props) { return (React.createElement("svg", __assign({ width: 13, height: 13, xmlns: "http://www.w3.org/2000/svg", role: "img" }, props),
    React.createElement("g", { fillRule: "nonzero", fill: "none" },
        React.createElement("path", { d: "M12.652 5.493c.783-1.002.173-2.476-1.09-2.631a1.637 1.637 0 0 1-1.424-1.424A1.635 1.635 0 0 0 7.507.348a1.63 1.63 0 0 1-2.013 0 1.636 1.636 0 0 0-2.631 1.09 1.637 1.637 0 0 1-1.424 1.424C.176 3.017-.434 4.491.349 5.493a1.637 1.637 0 0 1 0 2.014c-.783 1.002-.173 2.475 1.09 2.631a1.635 1.635 0 0 1 1.424 1.424 1.636 1.636 0 0 0 2.63 1.089 1.633 1.633 0 0 1 2.014 0 1.635 1.635 0 0 0 2.631-1.089 1.635 1.635 0 0 1 1.424-1.424c1.263-.156 1.873-1.629 1.09-2.631a1.637 1.637 0 0 1 0-2.014", fill: "#008057" }),
        React.createElement("path", { d: "m8.347 3.196.875.485L6.068 9.38a.5.5 0 0 1-.596.232l-.083-.037a.503.503 0 0 1-.077-.052.433.433 0 0 1-.094-.072l-2.48-2.456.708-.707 2.06 2.041 2.841-5.133Z", fill: "#FFF" })))); };
var Memo = (0, react_1.memo)(SvgCertifiedIconActive);
exports.default = Memo;
//# sourceMappingURL=CertifiedIconActive.js.map